module.exports = "<p>hello from work</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/route/public/work/work.component.pug
// module id = 1085
// module chunks = 1